// deepanshu_code

import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import '../../../assets/AdminCss/admin_users.css';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import AdminModal from './AdminModal';
import axios from 'axios';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import api from '../../../utils/api';
export const base_url = process.env.REACT_APP_API_URL;

const SuperAdmin = () => {
  const [activeList,setActiveList]=useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [modal,setModal]=useState({ action: null, id: null });
  const [users, setUsers]= useState()
  const [error, setError]= useState()
  const [loading, setLoading]=useState(false);
  const [money, setMoney]= useState();
  const [hist, setHist]= useState({});
  const [originalUsers, setOriginalUsers] = useState(); // Store original data
const [searchText, setSearchText] = useState("");
    // Toggle sidebar visibility
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
    const handleModal=(action, id)=>{
      // console.log('dta-id',id, 'action', action);
      setModal({ action:action , id:id});
    }

    const fetchUsers = useCallback(async () => {
      try {
          const auth=localStorage.getItem('admin');
        const response = await api.post('/api/webapi/admin/listMember', 
          {
            typeid: "1",
            pageno: 1,
            limit: 10,
            search: '',
            language: "vi",
          },
          {
            withCredentials: true,  // ✅ Send cookies with the request
            headers: {
              'Content-Type': 'application/json',
              Authorization:`${auth}`
            }
          }
        );
        // console.log('resp',response);

        if (!response.data.status) throw new Error('Failed to fetch users');
        const data = response.data.datas;
        // console.log('dta',data);
        setMoney(data[0].money);
        
        setUsers(data);
        setOriginalUsers(data);

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    },[]);
// console.log('cod',code);

    const fetchHist= useCallback(async(req, res)=> {
      const role= localStorage.getItem('role');
      const auth= localStorage.getItem('auth');
      // console.log('roleee',role);

      const respon= await api.post('/api/webapi/admin/chipHistory',
        {role},
        {
          headers:{
            'content-type':'application/json',
            Authorization:`${auth}`
          }
        }
      )

      // console.log('respp0',respon);
      const data= respon?.data.result;
      // console.log(data);
      if(respon?.data.success){
        setHist(data[0])
      }
    },[]);

    useEffect(() => {  
      fetchUsers();
      fetchHist();
    }, []);

    const handleChange = (e) => {
      const searchEle = e.target.value.toLowerCase(); // Convert input to lowercase for case-insensitive search
      setSearchText(searchEle);
    
      if (searchEle === "") {
        setUsers(originalUsers); // Reset to full data when input is cleared
        return;
      }
    
      const filteredData = originalUsers?.filter((item) =>
        item.invite.toLowerCase().includes(searchEle) // Case-insensitive search
      );
    
      console.log("Filtered Data:", filteredData);
      setUsers(filteredData);
    };

    const handleRefresh= ()=> {
        toast.success('Refreshing data...');
      fetchUsers();
    };
  
    function formateT(params) {
      let result = (params < 10) ? "0" + params : params;
      return result;
    }
    function timerJoin(params = '', addHours = 0) {
      let date = '';
      if (params) {
        date = new Date(Number(params));
      } else {
        date = new Date();
      }

      date.setHours(date.getHours() + addHours);

      let years = formateT(date.getFullYear());
      let months = formateT(date.getMonth() + 1);
      let days = formateT(date.getDate());

      let hours = date.getHours() % 12;
      hours = hours === 0 ? 12 : hours;
      let ampm = date.getHours() < 12 ? "AM" : "PM";

      let minutes = formateT(date.getMinutes());
      let seconds = formateT(date.getSeconds());

      return years + '-' + months + '-' + days + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm;
    }



    // const toggleLockFancyBetting = (event) => {
    //   // Implement toggle logic here
    //   console.log('Toggling fancy betting:', event.target?.id);
    // };
  
    // const toggleLockBetting = (event) => {
    //   // Implement toggle logic here
    //   console.log('Toggling betting:', event.target?.id);
    // };
  
   const toggleLockUser = async (currentStatus, userId) => {
  const newStatus = currentStatus === 1 ? 2 : 1;
  console.log("Toggling user", userId, "from status", currentStatus, "to", newStatus);

  try {
    const response = await axios.post(base_url + '/api/admin/lockUser',
      { status: newStatus, userId },
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

    if (response.data.success) {
      console.log('User status updated successfully');
      // Optional: refresh user data here
    } else {
      console.warn('User status update failed');
    }
  } catch (error) {
    console.error('Error updating user status:', error);
  }
};

useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
    if (loading) return <p>Loading users...</p>;
    if (error) return <p>Error: {error}</p>;

    
  return (
    <><div className="wrapper">
        {/* Main Sidebar */}
        {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        /> */}
        
        {/* Header - Pass mobile info */}
        {/* <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="side-body padding-top">
          <div className="container-fluid">
            <ul className="nav nav-tabs mobile_responsive user-nav">
              <li className={`${activeList === 0 ? 'active1' : ''} changecolor cursor-pointer`} onClick={() => setActiveList(0)}><a href="/admin/users" className="active" style={{ pointerEvents: 'none' }}>Admin</a></li>
            </ul>
            <div className='d-flex flex-wrap justify-content-between me-3'>
              <h1 className="page-title"><i className="sidebar-mini-person" />Super Admin</h1>
              <div className="pull-right topright_buttons d-flex gap-2">

                  <Link href="##" className="btn btn-success getsportsetting red_btn" onClick={(e) => {
                    e.preventDefault();  // ✅ Prevents reload
                    handleModal('add-admin', null);  // ✅ Triggers modal
                  }}><i className="fa fa-plus" />
                  Add Admin</Link>

              {/* <Link href="##" className="btn btn-success addAllTypeUsers red_btn" onClick={(e) => {
                    e.preventDefault();  // ✅ Prevents reload
                    handleModal('add', null);  // ✅ Triggers modal
                  }}><i className="fa fa-plus" />
                Add</Link> */}
              <Link title="A/c Chips In/Out" href="##" className="btn btn-sm btn-info masterorsmfront_chipsinout_admin color-1" onClick={(e) => {
                    e.preventDefault();  // ✅ Prevents reload
                    handleModal('chips-in-out', null);  // ✅ Triggers modal
                  }}>A/c Chips In/Out [Super
                Admin]</Link>
              <Link href="#" className="btn btn-danger getbalancesheet"><i className="fa fa-file" /> Export</Link>
            </div>
          </div>

        </div>
        <div id="sidebar-mini-notifications" />
        <div className="page-content browse container-fluid">
          <div className="alerts">
          </div>
          <div className="row me-0">
            <div className="col-md-12 oneonofftab">
              <div className="panel panel-bordered sportsNew">
                <div className="panel-body">
                  <table className="table table-hover dataTableuser table-responsive user-outer">
                  <thead>
                      <tr>
                        <th>Available Balance</th>
                        <th>Amount</th>
                        <th>Debit/Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{money}</td>
                        <td>{hist?.amount}</td>
                        <td>{hist?.type}</td>
                      </tr>

                    </tbody>
                  </table>
                  <form method="get" className="form-search add-users-outer">
                    <div id="search-input" className="bot_pdenew">
                      <div className="input-group col-md-12 newsearch2">
                        <div className="input-group col-md-2 borderClass">
                          <input type="text" id="myInput" className="form-control" placeholder="Search using invite" name="s" />
                        </div>
                        
                        <div className='d-flex gap-4'>
                        <div className="">
                          <input type="button" className="btn btn-primary btn-lg search p-1" defaultValue="Search" onChange={handleChange} />
                        </div>
                        <div className="">
                          <button type="button" onClick={handleRefresh} className="btn btn-lg search p-1">Refresh</button>
                        </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="dataTable mt-5">
                  <table id="dataTable" className="table table-hover dataTableuser table-responsive user-outer">
                    <thead>
                      <tr>
                        <th className='table-bg'><Link href="#">ID</Link></th>
                        <th className='table-bg'><Link href="#">User Name</Link></th>
                        <th className='table-bg'><Link href="#">Mobile Number</Link></th>
                        <th className='table-bg'><Link href="#">Password</Link></th>
                        <th className='table-bg'><Link href='#'>Role</Link></th>
                        <th className='table-bg'><Link href="#">Main Balance</Link></th>
                        <th className='table-bg'><Link href="#">Bonus</Link></th>
                        <th className='table-bg'><Link href="#">Taken Commission%</Link></th>
                        <th className='table-bg'><Link href="#">Given Commission%</Link></th>
                        <th className='table-bg'><Link href="#">Total Settled Amount</Link></th>
                        {/* <th className='table-bg'><Link href="#">Fancy Locked</Link></th>
                        <th className='table-bg'><Link href="#">Betting Locked</Link></th>
                        <th className='table-bg'><Link href="#">User Locked</Link></th> */}
                        <th className='table-bg'><Link href="#">Closed Account</Link></th>
                        <th className='table-bg'><Link href="#">Invite</Link></th>
                        <th className='table-bg'><Link href="#">Profit Loss</Link></th>
                        <th className='table-bg'><Link href="#">Created At</Link></th>
                        <th className="table-bg" >Actions</th>
                      </tr>
                    </thead>
                    <tbody className="admindata">
                      {users?.map((data) => (
                        (data.role==='super admin' &&<tr key={data.id}>
                          <td className="pdl0pdr0"><span>{data.id}</span></td>
                          <td className="pdl0pdr0">
                            <Link href="#" title="View Child User" style={{ color: '#000' }}>{data.username}</Link>
                          </td>
                          <td className="pdl0pdr0"><span>{data.phone}</span></td>
                          <td className="pdl0pdr0"><span>{data.plain_password}</span></td>
                          <td className="pdl0pdr0"><span>{data.role}</span></td>
                          <td className="pdl0pdr0">{data.money}</td>
                          <td className="pdl0pdr0"><span className="green">{data.bonus_money}</span></td>
                          <td className="pdl0pdr0"><span className="green">{data.commission}</span></td>
                          <td className="pdl0pdr0"><span className="green">{data.givecommission}</span></td>
                          <td className="pdl0pdr0"><span className="green">0.00</span></td>
                          {/* <td className="pdl0pdr0">
                            <div className="form-row customtoggle">
                              <div className="form-group" style={{ position: 'relative' }}>
                                <label htmlFor="lockuser" title="Self Lock"> Self Lock</label>
                                <div className="toggle_bx">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      name="lock_fancy_betting"
                                      id={data.id_user}
                                      value="1"
                                      defaultChecked={data.fancylocked === 1}
                                      onChange={(e) => toggleLockFancyBetting(e.target)} />
                                    <div className="slider round extratoggle" />
                                  </label>
                                </div>
                              </div>
                            </div>
                            {data.fancylocked === 1 ? "Yes" : data.fancylocked === 0 ? "No" : ""}
                          </td>
                          <td className="pdl0pdr0">
                            <div className="form-row customtoggle">
                              <div className="form-group" style={{ position: 'relative' }}>
                                <label htmlFor="lockuser" title="Self Lock"> Self Lock</label>
                                <div className="toggle_bx">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      name="lock_betting"
                                      id={data.id_user}
                                      value="1"
                                      defaultChecked={data.betlock === 1}
                                      onChange={(e) => toggleLockBetting(e.target)} />
                                    <div className="slider round extratoggle" />
                                  </label>
                                </div>
                              </div>
                            </div>
                            {data.betlock === 1 ? "Yes" : data.betlock === 0 ? "No" : ""}
                          </td>
                          <td className="pdl0pdr0">
                            <div className="form-row customtoggle">
                              <div className="form-group" style={{ position: 'relative' }}>
                                <label htmlFor="lockuser" title="Self Lock"> Self Lock</label>
                                <div className="toggle_bx">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      name="lock_user"
                                      id={data.id_user}
                                      value="1"
                                      defaultChecked={data.status === 1}
                                      onChange={(e) => toggleLockUserBetting(e.target)} />
                                    <div className="slider round extratoggle" />
                                  </label>
                                </div>
                              </div>
                            </div>
                            {data.status === 1 ? "Yes" : data.status === 0 ? "No" : ""}
                          </td> */}
                          <td className="pdl0pdr0">
                            <div className="form-row customtoggle">
                              <div className="form-group" style={{ position: 'relative' }}>
                                <label htmlFor="lockuser" title="Self Lock"> Self Lock</label>
                                <div className="toggle_bx">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      name="close_account"
                                      id={data.id_user}
                                      value="1"
                                      defaultChecked={data.status === 2}
                                     onChange={() => toggleLockUser(data.status, data.id_user)} />
                                    <div className="slider round extratoggle" />
                                  </label>
                                </div>
                              </div>
                            </div>
                            {/* {data.status === 1 ? "Yes" : data.status === 0 ? "No" : ""} */}
                          </td>
                          <td >{data.invite}</td>
                          <td className="pdl0pdr0">0.00</td>
                          <td className="pdl0pdr0">{timerJoin(data.time)}</td>
                          <td className="no-sort no-click" id="bread-actions">
                            <span className="dropdown user-more-btn">
                              <Link
                                href="#"
                                className="btn btn-xs btn-success"
                                onClick={(e) => { e.preventDefault(); handleModal('user-show', data.id); }}
                              >
                                View More <span className="caret" />
                              </Link>
                            </span>
                          </td>
                        </tr>)
                      ))}
                    </tbody>
                  </table>
                  <div className="pull-left">
                    <div role="status" className="show-res" aria-live="polite">{users?.length ? `Showing 1 to ${users?.length} of ${users?.length} entries` : "No entries to show"}
                    </div>
                  </div>
                  <div className="pull-right"> </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal modal-danger fade" tabIndex={-1} id="delete_modal" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
              <h4 className="modal-title"><i className="sidebar-mini-trash" /> Are you sure you want to delete this user?
              </h4>
            </div>
            <div className="modal-footer">
              <form action="#" id="delete_form" method="POST">
                <input type="hidden" name="_method" defaultValue="DELETE" />
                <input type="hidden" name="_token" defaultValue="DoQ41U4J92ipYmOflRWNVPRcNW09QmRFKMZpxtme" />
                <input type="submit" className="btn btn-danger pull-right delete-confirm" defaultValue="Yes, Delete it!" />
              </form>
              <button type="button" className="btn btn-default pull-right" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div id="myModal" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">×</button>
              <h4 className="modal-title">Password</h4>
            </div>
            <div className="modal-body">
              <label>Password</label>
              <input type="hidden" name="userid" className="userid" defaultValue />
              <input type="hidden" name="mono" id="mono" defaultValue={1111111111} />
              <input type="password" name="password" id="password" className="form-control" placeholder="Please enter password" />
              <div id="errormsg" />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" id="checkpassword">Search</button>
            </div>
          </div>
        </div>
      </div>
      <div id="myModal" className="modal fade in" role="dialog" style={{ paddingRight: 17 }}>
        <div className="modal-dialog">
          {/* Modal content*/}
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">×</button>
              <h4 className="modal-title">Password</h4>
            </div>
            <div className="modal-body">
              <label>Password</label>
              <input type="hidden" name="userid" id="userid" defaultValue="eyJpdiI6IkV0UkpTM2NpcEFYV1AyT1JJTDVoUVE9PSIsInZhbHVlIjoiVU10TkplYzNsZjd4T0E1MUNBa1RLZz09IiwibWFjIjoiMDY5MmE5YTRjNWE1MTYwMGUxNzc2NmNkMjQzMGJjOTczM2ZkNDg2ZTU0ZGY1NzJkNmY5ZWU0NDE4ZjljZGRlMCJ9" />
              <input type="password" name="password" id="password" className="form-control" placeholder="Please enter password" />
              <div id="errormsg" />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" id="checkpassword">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AdminModal modal={modal} setModal={setModal} data={users} />
      {<div id="overlayId" className={`overlay ${modal?.action?'d-block':'d-none'}`}></div>}

    </div>
    </>
  )
}
export default SuperAdmin;